<template>

    <iframe  :id="id" :src="url" frameborder="0" width="100%" height="800px" scrolling="auto" :allowfullscreen="true"></iframe>

</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN, USER_LANGUAGE, USER_NAME } from '@/store/mutation-types';
  import PageLayout from '../page/PageLayout'
  import RouteView from './RouteView'
  import store from '@/store/';
  import {  getAction} from '@/api/manage'
import Result from '@/views/result/Result';

  export default {
    name: "IframePageContent",
    inject:['closeCurrent'],
    data () {
      return {
        url: "",
        id:"",
        allUrl:"",
      }
    },
    created () {
      this.goUrl()
    },
    // updated () {
    //   this.goUrl()
    // },
    watch: {
      $route(to, from) {
        this.goUrl();
      }
    },
    methods: {
      goUrl () {
        let url = this.$route.meta.url
        this.id = this.$route.path
        let userName = this.$store.getters.userInfo.username
       
        
        if (url !== null && url !== undefined) {
            //url支持通过 ${token}方式传递当前登录TOKEN
            // let tokenStr = "${token}";
            // if(url.indexOf(tokenStr)!=-1) {
            //   let token = Vue.ls.get(ACCESS_TOKEN);
            //   this.url = url.replace(tokenStr, token);
            // } else {
            //   this.url = url
            // }

            //url支持通过 ${langCode}方式传递多语言
            let langStr = "${langCode}";
            if(url.indexOf(langStr)!=-1) {
              let langCode = window.sessionStorage.getItem(USER_LANGUAGE) || 'zh_CN'; 
              if(langCode==='vi_VN'){
                langCode = 'vi';
              }
              if(langCode==='en_US'){
                langCode = 'en';
              }
              this.allUrl = url.replace(langStr, langCode).replace('_','-');
            }
            //url支持通过 ${userName}传递 工号
            let nameStr = "${userName}"
            if(this.allUrl.indexOf(nameStr)!=-1) {
              this.allUrl = this.allUrl.replace(nameStr, userName);
            }

            getAction('/hhemp/CmsAPI/getTemporary',{username:userName}).then(res=>{
                 if(res.success){
                      let temp= res.result

                      let tempStr = "${temporary}"
                      if(this.allUrl.indexOf(tempStr)!=-1) {
                        this.allUrl = this.allUrl.replace(tempStr, temp);

                      }
                      this.url = this.allUrl

                      if(this.$route.meta.internalOrExternal != undefined && this.$route.meta.internalOrExternal==true){
                          this.closeCurrent();
                          window.open(this.url);
                      }
                 }else{
                    this.$message.error(res.message);
                 }
            })

        }
      }
    }
  }
</script>

<style>
</style>